export default "__VITE_ASSET__16cf6733__"